import permissions from 'common/security/permissions';
import usePermission from 'common/security/usePermission';
import { requestSnapshotQuote } from 'features/futuresContracts/futuresContracts.actions';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { BidsContext } from './BidTable';

import './SnapshotQuoteButton.scss';

const SnapshotQuoteButton: React.FC<any> = () => {

    const isAllowed = usePermission(permissions.UseSnapshotQuotes);
    const [isDisabled, setIsDisabled] = useState(false);

    if (!isAllowed) return null;
    
    const dispatch = useDispatch();

    const context = useContext(BidsContext);

    function requestQuote() {
        setIsDisabled(true);
        context.futuresContracts.forEach(fc => requestSnapshotQuote(dispatch, fc));
        setTimeout(() => {
            setIsDisabled(false);
        }, 5000)
    }

    return <button className="snapshot-quote-button link-button" 
        onClick={requestQuote} 
        disabled={isDisabled}
        title="Get snapshot quote for bids">
        <i className="material-icons">{isDisabled ? "done": "refresh"}</i>
    </button>;
}


export default SnapshotQuoteButton;